<template>
  <div class="wrapper">
    <div class="content">
      <div class="company-form">
        <!-- form header  -->
        <div class="header">
          <img
            src="@/assets/images/logo-lg.svg"
            class="unselectable"
            alt
            width="20%"
          />
          <p class="company-title">COMPANY DASHBOARD</p>
          <p class="company-subtitle">
            Create
          </p>
        </div>
        <!-- form tabs  -->
        <form-wizard
          class="custom-form-wizard custom-form-wizard-entity"
          color="#103F5E"
          step-size="sm"
        >
          <!-- Step 1  -->
          <tab-content :before-change="beforeTabOneSwitch">
            <p class="company-details">Company details</p>
            <!-- name   -->
            <div class="user-name company-input">
              <div class="input-wrapper">
                <div
                  class="form-group m-d-gruop"
                  :class="$v.entity.name.$error && 'invalid-value'"
                >
                  <b-form-input v-model="entity.name" type="text" required />
                  <label for="phone">Company Name</label>
                </div>
              </div>
              <div class="err-wrapper">
                <div v-if="submitted && !$v.entity.name.required">
                  <span class="error-value"> Name is required.</span>
                </div>
                <div v-else-if="submitted && !$v.entity.name.maxLength">
                  <span class="error-value"
                    >The maximum length is 30 characters.</span
                  >
                </div>
              </div>
            </div>
            <!-- Server -->
            <div class="company-input select-server">
              <div
                class="input-wrapper"
                :class="$v.server.$error && 'invalid-value'"
              >
                <multiselect
                  id="server"
                  class="custom-multi-select"
                  v-model="server"
                  :options="servers"
                  placeholder="Select Server"
                  label="server_name"
                  :show-labels="false"
                  :allowEmpty="true"
                >
                  <template slot="option" slot-scope="props">
                    <div class="option__desc">
                      <span
                        class="option__name font-weight-bold"
                        >{{ props.option.server_name }} ({{ props.option.notes }})</span
                      >
                    </div>
                  </template>
  
                  <template slot="singleLabel" slot-scope="{ option }">
                    <div class="option__desc">
                      <span
                        class="option__name font-weight-bold"
                        >{{ option.server_name }} ({{ option.notes }})</span
                      >
                    </div>
                  </template>
                </multiselect>
              </div>
              <div class="err-wrapper">
                <div v-if="submitted && !$v.server.required">
                  <span class="error-value"> Server is required.</span>
                </div>
              </div>
            </div>
            <!-- subdomain  -->
            <div class="subdomain company-input">
              <div class="input-wrapper">
              <div class="row-group phone-group justify-content-start w-100">
                <div
                  class="form-group m-d-gruop "
                  :class="
                    ($v.subdomainValue.$error ||
                      (subdomainInputTyping &&
                        (!getIsValidSubdomain || !checkSubdomain))) &&
                      'invalid-value'
                  "
                >
                  <b-form-input
                    id="subdomain"
                    autocomplete="off"
                    :disabled="!server"
                    v-model="subdomainValue"
                    type="text"
                    required
                    @keypress="onSubdomainInputTyping"
                    @paste="onSubdomainInputPaste"
                    @input="$v.subdomainValue.$touch()"
                  />
                  <label for="subdomain">Subdomain</label>
                </div>
              <div class="subdomain-server m-d-gruop" v-if="server">
                  <p class="mb-0">{{ subdomain }}</p>
                </div>
              </div>
              </div>
              <div class="err-wrapper">
                <div v-if="subdomainInputTyping && !$v.subdomainValue.required">
                  <span class="error-value">Subdomain is required.</span>
                </div>
                <div v-else-if="subdomainInputTyping && !$v.subdomainValue.containsSpace">
                  <span class="error-value">Subdomain should not includes any spaces.</span>
                </div>
                <div v-else-if="subdomainInputTyping && !checkSubdomain">
                  <span class="error-value">
                    Subdomain is not valid.
                  </span>
                </div>
                <div v-else-if="subdomainInputTyping && !getIsValidSubdomain">
                  <span class="error-value">
                    Subdomain is already used.
                  </span>
                </div>
              </div>
            </div>
            <!-- phone  -->
            <div class="company-input">
              <div class="input-wrapper">
                <div class="row-group w-100">
                  <VueCountryCode
                    class="country-code-input"
                    :disabledFetchingCountry="false"
                    @onSelect="onSelectCompanyCountryCode"
                    :enabledCountryCode="true"
                    :preferredCountries="['GB', 'US', 'CN']"
                  />
                  <div class="form-group m-d-gruop">
                    <b-form-input
                      id="phone"
                      v-model.trim="entity.company_phone"
                      type="text"
                      required
                    />
                    <label for="phone">Company Phone (Optional)</label>
                  </div>
                </div>
              </div>
              <div class="err-wrapper">
                <div v-if="submitted && !$v.entity.company_phone.numeric">
                  <span class="error-value">
                    Phone number should contain only digits.
                  </span>
                </div>
              </div>
            </div>
          </tab-content>
          <!-- Step 2  -->
          <!-- <tab-content :before-change="beforeTabTwoSwitch"> -->

            <!-- <div class="company-input select-device">
              <div class="input-wrapper">
                    <multiselect v-model="typeValue" :options="typeOptions" :searchable="false" :close-on-select="true" :show-labels="false" placeholder="Choose device type" class="custom-multi-select"></multiselect>
              </div>
            </div> -->

            <!-- <div id="doorContainer" v-show="this.typeValue=='Door'">
              <p class="company-details">Door details</p>
              <div class="row-group">
                <div class="android-serial company-input">
                  <div class="input-wrapper">
                    <div class="form-group m-d-gruop" :class="$v.door.name.$error && 'invalid-value'">
                      <b-form-input v-model="door.name" type="text" />
                      <label for="phone">Door Name</label>
                    </div>
                  </div>
                </div>
              </div>
            <div class="row-group">
              <div class="android-serial company-input">
                <div class="input-wrapper">
                  <div class="form-group m-d-gruop" :class="$v.door.id.$error && 'invalid-value'">
                    <b-form-input v-model="door.id" type="text"/>
                    <label for="phone">Door ID</label>
                  </div>
                </div>
              </div>
              </div>
            </div> -->

            <!-- <div id="kioskContainer" v-show="this.typeValue=='Kiosk'">
                <p class="company-details">Kiosk details</p> -->
                <!-- device select  -->
                <!-- <div class="company-input select-device">
                  <div class="input-wrapper">
                    <multiselect id="server" class="custom-multi-select" v-model="device" :options="deviceOptions"
                      placeholder="Purchased Device" label="name" :show-labels="false" :allowEmpty="true"
                      @select="addLamasatechSerial" />
                  </div>
                  <div class="err-wrapper">
                    <div v-if="submitted && !$v.server.required">
                      <span class="error-value">Purchased device is required.</span>
                    </div>
                  </div>
                </div>
                <div class="row-group kiosk-date-wrapper"> -->
                  <!-- kiosk name  -->
                  <!-- <div class="kiosk-name">
                    <div class="input-wrapper">
                      <div class="form-group m-d-gruop" :class="$v.kiosk.name.$error && 'invalid-value'">
                        <b-form-input v-model="kiosk.name" type="text" />
                        <label for="phone">Kiosk Name</label>
                      </div>
                    </div>
                    <div class="err-wrapper">
                      <div class="mb-0" v-if="submitted && !$v.kiosk.name.required">
                        <span class="error-value">Kiosk name is required</span>
                      </div>
                      <div class="mb-0" v-else-if="submitted && !$v.kiosk.name.maxLength">
                        <span class="error-value">The maximum length is 30 characters</span>
                      </div>
                    </div>
                  </div> -->
                  <!-- date  -->
                  <!-- <div class="purchase-date">
                    <div class="input-wrapper">
                      <div class="form-group m-d-gruop" :class="$v.kiosk.date_of_purchase.$error && 'invalid-value'">
                        <date-picker class="w-100" id="custom-date-picker" v-model="kiosk.date_of_purchase" :first-day-of-week="1"
                          lang="en" placeholder="Purchase Date" value-type="format" format="YYYY-MM-DD"></date-picker>
                      </div>
                    </div>
                    <div class="err-wrapper">
                      <div class="mb-0" v-if="submitted && !$v.kiosk.date_of_purchase.required">
                        <span class="error-value mb-0">Purchase Date is required.</span>
                      </div>
                    </div>
                  </div>
                </div> -->
                <!-- android serial  -->
                <!-- <div class="android-serial company-input">
                  <div class="input-wrapper">
                    <div class="form-group m-d-gruop input-icons" :class="$v.kiosk.android_serial.$error && 'invalid-value'">
                      <b-form-input class="input-field" v-model="kiosk.android_serial" type="text" />
                      <i :class="{'show-icon': !$v.kiosk.android_serial.$invalid, 'hide-icon': $v.kiosk.android_serial.$invalid}" class="icon fa fa-check"></i>
                      <label for="phone">Android Serial Number</label>
                    </div>
                  </div>
                  <div class="err-wrapper">
                    <div v-if="submitted && !$v.kiosk.android_serial.required">
                      <span class="error-value">
                        Android Serial number is required.</span>
                    </div>
                    <div v-if="submitted && !$v.kiosk.android_serial.alphaNum">
                      <span class="error-value">Please enter Android Serial alphaNum.</span>
                    </div>
                    <div v-if="submitted && !$v.kiosk.android_serial.minLength">
                      <span class="error-value">Android Serial should be at least 10 charcters.</span>
                    </div>
                    <div v-if="submitted && !$v.kiosk.android_serial.containsUppercase">
                      <span class="error-value">Android Serial should contain capital letters only.</span>
                    </div>
                  </div>
                </div> -->
                <!-- mac_address  -->
                <!-- <div class="mac-address company-input">
                  <div class="input-wrapper">
                    <div class="form-group m-d-gruop input-icons" :class="$v.kiosk.mac_address.$error && 'invalid-value'">
                      <b-form-input class="input-field" v-model="kiosk.mac_address" type="text" />
                      <i :class="{'show-icon': !$v.kiosk.mac_address.$invalid, 'hide-icon': $v.kiosk.mac_address.$invalid}" class="icon fa fa-check"></i>
                      <label for="phone">MAC Address</label>
                    </div>
                  </div>
                  <div class="err-wrapper">
                    <div v-if="submitted && !$v.kiosk.mac_address.required">
                      <span class="error-value">
                        MAC Address is required.</span>
                    </div>
                    <div v-if="submitted && !$v.kiosk.mac_address.alphaNum">
                      <span class="error-value">Please enter MAC Address alphaNum.</span>
                    </div>
                    <div v-if="submitted && !$v.kiosk.mac_address.minLength">
                      <span class="error-value">Please enter MAC Address 12 charcter.</span>
                    </div>
                    <div v-if="submitted && !$v.kiosk.mac_address.containsUppercase">
                      <span class="error-value">MAC Address should contain capital letters only.</span>
                    </div>
                  </div>
                </div>
                <hr class="h-line mac-serial-line" /> -->
                <!-- lamasatech-serial  -->
                <!-- <div class="lamasatech-serial company-input">
                  <div class="input-wrapper">
                    <div class="form-group m-d-gruop" :class="$v.kiosk.lamasatech_serial.$error && 'invalid-value'">
                      <b-form-input v-model="kiosk.lamasatech_serial" type="text" :disabled="!device" />
                      <label for="phone">LamasaTech Serial</label>
                    </div>
                  </div>
                  <div class="err-wrapper">
                    <div v-if="submitted && !$v.kiosk.lamasatech_serial.required">
                      <span class="error-value">
                        LamasaTech Serial is required.</span>
                    </div>
                    <div v-else-if="submitted && !$v.kiosk.lamasatech_serial.numeric">
                      <span class="error-value">
                        LamasaTech serial should be only numbers.</span>
                    </div>
                    <div v-else-if="submitted && !$v.kiosk.lamasatech_serial.minLength">
                      <span class="error-value">
                        LamasaTech serial should be at least 14 digits</span>
                    </div>
                  </div>
                </div> -->
                <!-- purchased from  -->
                <!-- <p class="purchased-from-text">Purchased from</p>
                <div class="d-flex align-items-center radio-check">
                  <b-form-radio class="text-muted" v-model="kiosk.purchased_from" value="LamasaTech">LamasaTech
                  </b-form-radio>
                  <b-form-radio class="mx-4 text-muted" v-model="kiosk.purchased_from" value="Partner">Partner
                  </b-form-radio>
                </div> -->
                <!-- parent name -->
                <!-- <div class="parent-name company-input" v-if="kiosk.purchased_from == 'Partner'">
                  <div class="input-wrapper">
                    <div class="form-group m-d-gruop" :class="$v.kiosk.partner_name.$error && 'invalid-value'">
                      <b-form-input v-model="kiosk.partner_name" type="text" />
                      <label for="phone">Partner Name</label>
                    </div>
                  </div>
                  <div class="err-wrapper">
                    <div v-if="submitted && !$v.kiosk.partner_name.required">
                      <span class="error-value">Partner name is required</span>
                    </div>
                  </div>
                </div>
            </div>

            
          </tab-content> -->
          <p class="slot-prev mb-0" slot="prev">Back</p>
          <p :disabled="getLoading" class="slot-next mb-0" slot="next">
            Next
          </p>
          <b-button
            v-if="false"
            class="w-lg register-btn d-none"
            :disabled="getLoading"
            variant="primary"
            slot="finish"
          >
            <i
              v-if="getLoading"
              class="
                bx bx-hourglass bx-spin
                font-size-16
                align-middle
                mr-2
              "
            ></i>
            <span v-else>CREATE</span>
          </b-button>
        </form-wizard>
        <button
          class="btn btn-primary btn-block submit-btn"
          type="button"
          @click="onSubmit"
          :disabled="getLoading || disableSubmitBtn"
        >
          <i
            v-if="getLoading"
            class="bx bx-loader bx-spin font-size-16 align-middle mr-2 rounded"
          ></i>
          <span v-else>CREATE</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import {
  required,
  // alphaNum,
  numeric,
  // minLength,
  maxLength,
  // requiredIf,
} from "vuelidate/lib/validators";
// import DatePicker from "vue2-datepicker";
import isValidDomain from "is-valid-domain";
import Multiselect from "vue-multiselect";
import VueCountryCode from "vue-country-code";
import "vue2-datepicker/index.css";
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";

export default {
  name: "CreateCompany",
  components: {
    // DatePicker,
    Multiselect,
    VueCountryCode,
    FormWizard,
    TabContent,
  },
  data() {
    return {
      typeValue: '',
      typeOptions: ['Kiosk', 'Door'],
      servers: [],
      server: null,
      device: "",
      userId: null,
      companyCountryCode: null,
      deviceOptions: [
        { id: "LT-Zentron8", name: "LT-Zentron8" },
        { id: "LD-AITemp", name: "LD-AITemp" },
        { id: "Zentron 15", name: "Zentron 15" },
      ],
      entity: {
        name: null,
        subdomain: null,
        company_phone: null,
        package: "Standalone",
      },
      name: "",
      // door: {
      //   name: null,
      //   id: null,
      // },
      // kiosk: {
      //   name: null,
      //   mac_address: null,
      //   lamasatech_serial: null,
      //   date_of_purchase: null,
      //   android_serial: null,
      //   purchased_from: "LamasaTech",
      //   partner_name: null,
      // },
      submitted: false,
      subdomainInputTyping: false,
      subdomain: "",
      phone: null,
      subdomainValue: null,
      phone_input: null,
      phoneInputTyping: false,
      openKioskInfo: false,
    };
  },
  validations: {
    entity: {
      name: { required, maxLength: maxLength(30) },
      subdomain: { 
        required,
       },
      company_phone: { numeric },
      package: { required },
    },
    // door: {
    //   name: {
    //     required: requiredIf(function() {
    //       return this.typeValue == 'Door';
    //     }) , maxLength: maxLength(30) },
    //   id: {
    //     required: requiredIf(function () {
    //       return this.typeValue == 'Door';
    //     }), maxLength: maxLength(25) },
    // },
    // kiosk: {
      
    //   name: {
    //     required: requiredIf(function () {
    //       console.log('inside name requiredif ',this.typeValue);
    //       return this.typeValue == 'Kiosk';
    //     }),  maxLength: maxLength(30) },
    //   date_of_purchase: {
    //     required: requiredIf(function () {
    //       return this.typeValue == 'Kiosk';
    //     }) },
    //   android_serial: {
    //     required: requiredIf(function () {
    //       return this.typeValue == 'Kiosk';
    //     }),
    //     alphaNum,
    //     minLength: minLength(10),
    //     containsUppercase: function(value) {
    //       return (/^[A-Z0-9]*$/).test(value)
    //     },
    //   },
    //   mac_address: {
    //     required: requiredIf(function () {
    //       return this.typeValue == 'Kiosk';
    //     }),
    //     alphaNum,
    //     minLength: minLength(12),
    //     containsUppercase: function(value) {
    //       return (/^[A-Z0-9]*$/).test(value)
    //     },
    //   },
    //   partner_name: { 
    //     required: requiredIf(function() {
    //       const { kiosk:{purchased_from} } = this;
    //       return purchased_from == 'Partner' && this.typeValue == 'Kiosk' ? true : false;
    //     })
    //      },
    //   lamasatech_serial: {
    //     required: requiredIf(function () {
    //       return this.typeValue == 'Kiosk';
    //     }),
    //     numeric,
    //     minLength: minLength(14),
    //   },
    // },
    subdomainValue: { required ,
        containsSpace: function(value) {
          return /^([a-zA-Z0-9][a-zA-Z0-9-_]*\.)*[a-zA-Z0-9]*[a-zA-Z0-9-_]*[[a-zA-Z0-9]+$/.test(value);
        },
    },
    phone: { numeric },
    // device: {
    //   required: requiredIf(function () {
    //     return this.typeValue == 'Kiosk';
    //   }) },
    phone_input: { numeric, maxLength: maxLength(15) },
    server: { required },
  },
  watch: {
    getModalState(state) {
      state && this.$bvModal.hide("createCompany");
    },
    server(server) {
      if (server) {
        let domain = server.server_name;
        if (domain.indexOf("https://") > -1)
          domain = domain.replace("https://", "");

        if (domain.indexOf("http://") > -1) {
          domain = domain.replace("http://", "");
        }
        this.subdomain = "." + domain;
      } else {
        this.subdomainValue = null;
      }
    },
    // device(device) {
    //   if (!device || device.length == 0) {
    //     this.kiosk.lamasatech_serial = null;
    //   }
    // },
    getServer(getServer) {
      this.servers = JSON.parse(JSON.stringify(getServer));
    },
    subdomainValue(subdomainValue) {
      if (
        (subdomainValue && subdomainValue.includes(".")) ||
        (subdomainValue && subdomainValue.includes("_"))
      )
        return false;
      const completeSubdomain = `${subdomainValue}${this.subdomain}`
        .replace(/\s/g, "")
        .toLowerCase();
      const validSubdomain = isValidDomain(completeSubdomain, {
        subdomain: true,
        wildcard: false,
      });
      if (subdomainValue && validSubdomain) {
        this.entity.subdomain = completeSubdomain;
        this.subdomainInputTyping = true;
        this.checkEntitySubdomain({
          subdomain: completeSubdomain,
          server: this.server,
        });
      }
    },
    getIsValidSubdomain(value) {
      if (this.checkSubdomain && value) {
        this.openKioskInfo = true;
      } else this.openKioskInfo = false;
    },
    checkSubdomain(value) {
      if (this.getIsValidSubdomain && value) {
        this.openKioskInfo = true;
      } else this.openKioskInfo = false;
    }
  },
  computed: {
    ...mapGetters("entity", [
      "getLoading",
      "getIsValidSubdomain",
      "getModalState",
    ]),
    ...mapGetters("authfack", ["userDetails", "getPhoneDuplicatedCheck"]),
    ...mapGetters("server", ["getServer"]),
    checkSubdomain() {
      if (
        (this.subdomainValue && this.subdomainValue.includes(".")) ||
        (this.subdomainValue && this.subdomainValue.includes("_"))
      )
        return false;
      const completeSubdomain = `${this.subdomainValue}${this.subdomain}`
        .replace(/\s/g, "")
        .toLowerCase();
      const validSubdomain = isValidDomain(completeSubdomain, {
        subdomain: true,
        wildcard: false,
      });
      return validSubdomain ? true : false;
    },
    disableSubmitBtn() {
      const { entity } = this;
      return !(entity.name && entity.subdomain && this.openKioskInfo);
    },
  },
  methods: {
    ...mapActions("entity", [
      "createEntity",
      "checkEntitySubdomain",
      "resetState",
    ]),
    ...mapActions("entities", [
      "fetchUserEntities",
    ]),
    ...mapActions("server", ["getServers"]),
    onSubmit() {
      console.log(this.typeValue);
      this.submitted = true;
      this.$v.$touch();
      console.log("after touch() line 597");
      this.entity.subdomain = null;
      this.entity.company_phone = null;
      this.entity.company_phone =
        this.phone && this.phone > 0
          ? `${this.companyCountryCode}${this.phone}`
          : null;
      this.entity.subdomain = this.subdomainValue + this.subdomain;
      // stop here if form is invalid
      console.log('stop here if form is invalid');
      console.log(this.$v);
      if (!this.$v.$invalid) {
        console.log('before submit');
        const { entity, typeValue } = this;
        if (this.checkSubdomain && this.getIsValidSubdomain) {
          
          this.createEntity({
            user: { passport_id: this.userId },
            entity,
            // kiosk,
            // door,
            typeValue,
            // lamasatech_serial: { id: kiosk.lamasatech_serial },
            server: this.server,
          }).then(() => {
            this.fetchUserEntities();
          });
        } else {
          this.$toast.error("Please add a valid subdomain!.", {
            position: "top-right",
          });
        }
      }
    },
    addLamasatechSerial(selectedOption) {
      switch (selectedOption.name) {
        case "LD-AITemp":
          return (this.kiosk.lamasatech_serial = "7091135919162XXXXX");
        case "LT-Zentron8":
          return (this.kiosk.lamasatech_serial = "7091136435555XXXXX");
        case "Zentron 15":
          return (this.kiosk.lamasatech_serial = "5060861160027XXXXX");
        default:
          "";
      }
    },
    onSubdomainInputTyping() {
      return (this.subdomainInputTyping = true);
    },
    onSubdomainInputPaste() {
      return (this.subdomainInputTyping = true);
    },
    onSelectCompanyCountryCode({ dialCode }) {
      this.companyCountryCode = dialCode;
    },
    beforeTabOneSwitch() {
      this.subdomainInputTyping = true;
      if (!this.$v.entity.$invalid && !this.$v.subdomainValue.$invalid && !this.$v.server.$invalid) {
        this.$v.$reset();
        this.submitted = false;
      } else {
        this.$v.$touch();
        this.submitted = true;
        return;
      }
      if (this.checkSubdomain && this.getIsValidSubdomain) {
        return new Promise((resolve) => {
          this.openKioskInfo = true;
          resolve(!this.$v.entity.$invalid);
        });
      }
    },
    beforeTabTwoSwitch() {
      console.log('inside beforeTabTwoSwitch');
      if (!this.$v.form.kiosk.$invalid) {
        alert('invalid kiosk form');
        this.$v.$reset();
        this.submitted = false;
      } else {
        this.$v.$touch();
        this.submitted = true;
      }
      return new Promise((resolve) => {
        resolve(!this.$v.form.kiosk.$invalid);
      });
    },
    onPhoneInputTyping() {
      return (this.phoneInputTyping = true);
    },
    onTypeChange(value) {
      this.typeValue = value
      console.log(this.typeValue);
    },
  },
  beforeMount() {
    this.resetState();
    this.getServers();
  },
  mounted() {
    this.userId = JSON.parse(localStorage.getItem("user")).data.user.id;
  },
};
</script>

<style lang="scss" scoped>
.show-icon {
  display: block !important;
}
.hide-icon {
  display: none !important;
}
.input-icons i {
  position: relative;
  float: right;
  padding-right: 15px;
}
  
.input-icons {
  width: 100%;
  margin-bottom: 10px;
}
  
.icon {
  // padding: 10px;
  margin: -16px;
  color: #34c38f;
  min-width: 50px;
  text-align: center;
}
  
.input-field {
  width: 100%;
  padding: 10px;
  // text-align: center;
}

.company-form {
  .header {
    display: flex;
    align-items: center;
    flex-direction: column;
    text-align: center;
    margin-bottom: 17px;
    img {
      margin-bottom: 18px;
    }
    .company-title {
      font-style: normal;
      font-weight: bold;
      font-size: 20px;
      text-align: center;
      color: #000000;
      text-transform: uppercase;
      margin-bottom: 9px;
    }
    .company-subtitle {
      font-weight: bold;
      font-size: 16px;
      color: rgba(0, 0, 0, 0.28);
      margin-bottom: 0;
    }
  }
  .company-details {
    font-weight: 900;
    font-size: 20px;
    color: #939393;
    opacity: 0.46;
  }
  .company-input {
    margin-bottom: 17px;
    width: 100%;
    .input-wrapper {
      height: 55px;
      display: flex;
      align-items: center;
    }
  }
  .kiosk-date-wrapper {
      margin-bottom: 17px;
  }
  .select-server,
  .select-device {
    .input-wrapper {
      display: flex;
      align-items: center;
      background-color: #f3f3f3;
    }
  }
  .date_of_purchase {
    height: 55px;
  }
  .row-group {
    display: flex;
    justify-content: space-between;
  }
  .phone-input-wrapper {
    display: grid;
    grid-template-columns: 20% 80%;
  }
  .phone-input {
    border-radius: 0px 0.25rem 0.25rem 0px;
  }
  .kiosk-name {
    margin-right: 16px;
  }
  .mac-serial-line {
    margin: 15px 0 !important;
  }
  .purchased-from-text {
    font-weight: bold;
    font-size: 16px;
    letter-spacing: 0.25px;
    color: #787878;
    margin-bottom: 29px;
  }
  .radio-check,
  .purchased-from-text {
    padding-left: 20px;
  }
  .radio-check{
    margin-bottom: 5px;
  }
  .submit-btn {
    width: 100%;
    height: 44px;
    font-size: 16px;
    border-radius: 22px;
    text-transform: uppercase;
    font-weight: bold;
    color: rgba(255, 255, 255, 0.87);
    margin: 20px 0;
  }
}
</style>
